<div class="page-title" fxLayout="row" fxLayoutAlign="space-between center">
  <div fxLayout="column">
    <header *ngIf="loading; else header" class="skeleton">
      &nbsp;
    </header>
    <ng-template #header>
      <header>
        <ng-container *ngIf="breadcrumbs">
          <ng-container *ngFor="let breadcrumb of breadcrumbs">
            <ng-container *ngIf="breadcrumb">
              <a [routerLink]="breadcrumb.url">{{ breadcrumb.text }}</a> &raquo;
            </ng-container>
          </ng-container>
        </ng-container>
        {{ title }}
        <a
          *ngIf="help"
          matTooltip="Open the Help Center"
          [href]="help"
          target="_blank"
        >
          <mat-icon [inline]="true">help</mat-icon>
        </a>
      </header>
    </ng-template>
    <div *ngIf="loading && description != null" class="skeleton"></div>
    <div *ngIf="!loading && description && description.length > 0" class="text-secondary">
      {{ description }}
    </div>
  </div>

  <div fxFlex fxLayout="row" fxLayoutAlign="end center">
    <ng-content></ng-content>
  </div>
</div>
